import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { FullPageLoader } from '@/components/ui/LoadingSpinner';

import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import styles from './AppLayout.module.css';

/** Authenticated application shell: top navbar, main content and footer. */
export function AppLayout() {
  return (
    <div className={styles.layout}>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <AppHeader />
      <main id="main-content" className={styles.content} tabIndex={-1}>
        <Suspense fallback={<FullPageLoader label="Loading page…" />}>
          <Outlet />
        </Suspense>
      </main>
      <AppFooter />
    </div>
  );
}
